export default {
  en: {
    to: 'To',
    cc: 'Cc',
    bcc: 'Bcc',
    marketList: 'Market List',
    agentList: 'Agent List',
    agentTypeList: 'Agent Type List',
    more: 'More'
  },
  th: {
    to: 'ส่งถึง',
    cc: 'Cc',
    bcc: 'Bcc',
    marketList: 'ตลาด',
    agentList: 'ตัวแทน',
    agentTypeList: 'ประเภทตัวแทน',
    more: 'เพิ่มเติม'
  }
}
